export function toNumberOrUndefined(value) {
  if (value === '' || value === null || value === undefined) return undefined
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined
  }

  const parsed = Number(String(value).trim())
  return Number.isFinite(parsed) ? parsed : undefined
}

export function zodFieldErrors(error) {
  const errors = {}

  for (const issue of error?.issues ?? []) {
    const key = issue.path.filter((part) => part !== undefined).join('.')
    if (!key || errors[key]) continue
    errors[key] = issue.message
  }

  return errors
}

export function parseZod(schema, data) {
  const result = schema.safeParse(data)

  if (result.success) {
    return {
      success: true,
      data: result.data,
      errors: {},
      message: null,
    }
  }

  return {
    success: false,
    data: null,
    errors: zodFieldErrors(result.error),
    message:
      result.error.issues[0]?.message || 'Please fix the highlighted fields.',
  }
}

export function getBackendFieldErrors(error) {
  const payload = error?.response?.data || error?.data
  const details = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : []

  const errors = {}

  for (const item of details) {
    const path = typeof item?.path === 'string' ? item.path : ''
    const message = typeof item?.message === 'string' ? item.message.trim() : ''
    if (!path || !message || errors[path]) continue
    errors[path] = message
  }

  return errors
}

export function scrollToFirstError() {
  const field = document.querySelector('[data-invalid="true"]')
  field?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
